import React, { useState, useEffect } from 'react';
import { PrimaryButtonFilter } from '../../../components/buttons/PrimaryButton';
import axios from 'axios'
import { authHeader } from '../../../helpers/usertoken/UserToken';
import { useSelector } from 'react-redux';
import { Input, Pagination } from 'antd'
import toast, { Toaster } from "react-hot-toast";

import FmsDashboardMainRoot from '../FmsDashboardMainRoot';
import { Row,Col } from 'antd'
import { AiOutlineFilter } from 'react-icons/ai';
import { BiReset } from "react-icons/bi";

function FmsActiveCollegues() {

  const [activetab,setactivetab] = useState('1')
  const [roles_arr, setroles_arr] = useState([])
  const [employee, setemployee] = useState([])
  const [page, setpage] = useState('1')
  const [pagination, setpagination] = useState({})


  const [search_employee, setsearch_employee] = useState({ employee_id: '', })
  const theme_color = useSelector(state=>state.Theme.theme_color)


  useEffect(() => {
      getActiveOnboardedEmployee()
    
  }, [page])

  useEffect(()=>{
    setpage(1)
    getActiveOnboardedEmployee(1)
  },[])





 

 async function getActiveOnboardedEmployee(v) {
   await axios.get(`fms/fms_in_house_employee/get-active-or-nonactive/active/${page}`, authHeader)
      .then((res) => {
        setpagination(res.data.pagination)
        setemployee(res.data.datas)
      })
  }



  

  
 
  function applyfilter() {
    if (search_employee.employee_id) {
      axios.get(`fms/fms_in_house_employee/search?search=${search_employee.employee_id}&page=1&activetab=${activetab}`, authHeader)
        .then((res) => {
            setpagination(res.data.pagination)
            setemployee(res.data.datas.filter(d => d.isActive === true))
        }).catch((err) => {
        })
    } else {
      toast.error('Enter a valid FMS ID for filter')
    }
  }

  function resetfilter() {
    setsearch_employee({ ...search_employee, employee_id: '' })
    getActiveOnboardedEmployee()
  }

  function setpagefun(v) {
    setpage(v)
  }


  return (
    <FmsDashboardMainRoot>

    <div style={{ width: '95%',  marginTop: '-10px', }}>
      <Toaster />

      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between',paddingBottom:'5px',borderBottom:'1px solid #ddd'}}>
        <h6 style={{ fontWeight: '600',fontSize:'15px' }}>My Collegues</h6>

        <div style={{display:'flex',alignItems:'center'}}>
          <Input placeholder="Search Employee" type="text" style={{marginRight:0,width:'120px'}} value={search_employee.employee_id} onChange={(e)=>setsearch_employee({...search_employee,employee_id:e.target.value})} />
          <BiReset onClick={resetfilter} size={30} style={{background:'#e3e3e3',color:'#000',padding:7,margin:'0px 10px',borderRadius:5}} />
          <AiOutlineFilter onClick={applyfilter} size={30} style={{background:'#0e68bf',color:'#fff',padding:7,marginRight:5,borderRadius:5}} />
        </div>
      </div>



          <div style={{ width: '100%', margin: 'auto', marginBottom: '100px' }}>

            <Row style={{marginTop:'10px',cursor:'pointer'}}>
            {employee?.map((d,i)=>(
                <Col span={4} style={{border:'1px solid #eee',marginRight:'1%',marginBottom:'10px'}}>
                    <div style={{padding:'5px',background:'white'}}>
                       <h6 style={{fontSize:'11px',padding:'0px'}}>Name : <span style={{fontWeight:'800'}}>{d?.name}</span></h6>  
                       <h6 style={{fontSize:'11px',padding:'0px'}}>Employee Id : {d?.employee_id}</h6>  
                       <h6 style={{fontSize:'11px',padding:'3px'}}>Official phone : {d?.official_phone}</h6>  
                       <h6 style={{fontSize:'11px',padding:'3px'}}>Offical Email : {d?.official_email}</h6>  
                       <h6 style={{fontSize:'11px',padding:'4px',textTransform:'capitalize'}}>Department / Designation : {d?.department_id?.department_name} /  {d?.designation_id?.designation_name}</h6>  
                    </div>         
                </Col>))}
            </Row>    
      

              <div style={{ width: '100%', display: 'flex', justifyContent: 'center', margin: '40px auto' }}>
                  {pagination.total > pagination?.limit &&
                    <Pagination showSizeChanger={false} current={page} size="small" total={pagination.total} onChange={(v) => setpagefun(v)}  pageSize={pagination?.limit} />
                  }
              </div> 
             
          </div>
      

    </div>
    </FmsDashboardMainRoot>

  )
}

export default FmsActiveCollegues;
